import React from "react";
import styled from "styled-components";
import { Tooltip } from 'antd';

const QuestionMark = ({ children, title, url, ...props }) => {
  if (url) {
    return (
      <Icon onClick={() => {
        window.open(url, "_blank");
      }} {...props}>?</Icon>
    );
  }

  return (
    <Tooltip title={title}>
      <Icon {...props}>?</Icon>
    </Tooltip>
  );

};

const Icon = styled.div`
  background-color: var(--aia-bx-blue-2);
  color: var(--aia-bx-white);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  line-height: 0px;
  cursor: pointer;
  margin-bottom: 8px;
  &:hover {
    background-color: var(--aia-bx-blue-6);
  }
`;

export default QuestionMark;